import './hash-compat' // 必须第一个：在 router 求值前把旧版 hash 链接重定向为 history 路径
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import './style.css'
import { goto, gotoReplace, initScrollGuard } from './utils/nav'

// 滚动未停稳时的误触保护（点A跳B 的根因防护）
initScrollGuard()

// iOS Safari 点分享面板时，WebKit 内部脚本会把错误冒泡到页面（被遮罩成无文件名的 "Script error"），
// 与业务代码无关但会打进控制台；取消默认上报让控制台保持干净。
// 条件收窄为"无文件名的 Script error"：自己代码的错误都带文件名行号，不会被误拦。
window.addEventListener('error', (e) => {
  if (e.message === 'Script error' && !e.filename) {
    e.preventDefault()
  }
})

// Vant 完整 CSS 导入（兼容 webpack 5）
import 'vant/lib/index.css'

// Vant 组件按需导入
import {
  Tabbar,
  TabbarItem,
  Search,
  Swipe,
  SwipeItem,
  NavBar,
  Grid,
  GridItem,
  Icon,
  CountDown,
  Progress,
  Cell,
  CellGroup,
  Button,
  Tag,
  Image as VanImage,
  Loading,
  Sticky,
  Tabs,
  Tab,
  Field,
  Dialog,
  PullRefresh,
  List,
  Checkbox,
  Empty,
  Uploader,
  Area,
  Popup,
  SwipeCell,
  Radio,
  RadioGroup
} from 'vant'

const app = createApp(App)

// 整页导航方法（模板和 JS 里通用）：
// $goto 跳转、$gotoReplace 替换跳转，均走真实浏览器导航
app.config.globalProperties.$goto = goto
app.config.globalProperties.$gotoReplace = gotoReplace

// 注册路由
app.use(router)

// 注册 Vant 组件
app.use(Tabbar)
app.use(TabbarItem)
app.use(Search)
app.use(Swipe)
app.use(SwipeItem)
app.use(NavBar)
app.use(Grid)
app.use(GridItem)
app.use(Icon)
app.use(CountDown)
app.use(Progress)
app.use(Cell)
app.use(CellGroup)
app.use(Button)
app.use(Tag)
app.use(VanImage)
app.use(Loading)
app.use(Sticky)
app.use(Tabs)
app.use(Tab)
app.use(Field)
app.use(Dialog)
app.use(PullRefresh)
app.use(List)
app.use(Checkbox)
app.use(Empty)
app.use(Uploader)
app.use(Area)
app.use(Popup)
app.use(SwipeCell)
app.use(Radio)
app.use(RadioGroup)

app.mount('#app')

// 移除启动加载层（渐隐后删除，加载层样式内联在 public/index.html）
const appLoading = document.getElementById('app-loading')
if (appLoading) {
  appLoading.classList.add('app-loading-hide')
  setTimeout(() => appLoading.remove(), 350)
}
